export default __webpack_public_path__ + "static/media/ad-counter.1340676a.svg";